"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeCssVariables = exports.getStyleParamCssVariables = exports.getSiteCssVariables = exports.getComponentCssVariables = void 0;
var tpa_settings_1 = require("@wix/tpa-settings");
var wix_site_theme_variables_1 = require("@wix/wix-site-theme-variables");
var generateTPAParams_1 = require("./generateTPAParams");
var processor_1 = require("./processor");
var cssFunctions_1 = require("./cssFunctions");
var common_1 = require("./common");
var wixStyleFontUtils_1 = require("./utils/wixStyleFontUtils");
var css_variables_utils_1 = require("./css-variables.utils");
var editor_platform_ooi_metadata_resolver_1 = require("@wix/editor-platform-ooi-metadata-resolver");
var prefixes = {
    siteColors: 'wix',
    textPresets: 'wix-font', // --wix-font-{name}
};
function getComponentCssVariables(styles, customExpressions, cssVars, customOptions, defaults, customCssVars, tpaData, siteThemeVars) {
    var cssVariables = {};
    var options = __assign(__assign({}, common_1.defaultOptions), (customOptions || {}));
    var _a = (0, generateTPAParams_1.generateTPAParamsWithMetadata)({
        siteColors: styles.siteColors,
        siteTextPresets: styles.siteTextPresets,
        styleParams: styles.styleParams,
        options: options,
        defaults: defaults,
        siteThemeVars: siteThemeVars,
    }), tpaParams = _a.tpaParams, styleParamsWithMetadataDefaults = _a.styleParamsWithMetadataDefaults;
    // globals
    cssVariables['--wix-direction'] = options.isRTL ? 'rtl' : 'ltr';
    // numbers
    Object.entries(tpaParams.numbers).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, cssFunctions_1.cssFunctions.number(value));
        cssVariables[cssVariable.key] = cssVariable.value;
    });
    // strings
    Object.entries(tpaParams.strings).forEach(function (_a) {
        var key = _a[0], font = _a[1];
        var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, font.value);
        cssVariables[cssVariable.key] = cssVariable.value;
    });
    // colors
    var colorKeys = Object.keys(defaults !== null && defaults !== void 0 ? defaults : {})
        .filter(function (key) { return defaults[key].type === tpa_settings_1.StyleParamType.Color; })
        .map(function (key) { return defaults[key].key || key; });
    Object.entries(tpaParams.colors)
        .filter(function (_a) {
        var key = _a[0];
        return styles.styleParams.colors[key] || colorKeys.includes(key);
    })
        .forEach(function (_a) {
        var key = _a[0], color = _a[1];
        try {
            var rgbParts = (0, cssFunctions_1.toRgbParts)(cssFunctions_1.cssFunctions.color(color, tpaParams));
            var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, rgbParts.full);
            cssVariables[cssVariable.key] = cssVariable.value;
            (0, css_variables_utils_1.addColorSubVariables)({ cssVariable: cssVariable, rgbParts: rgbParts }, cssVariables);
        }
        catch (e) {
            // swallow
        }
    });
    // fonts
    Object.entries(tpaParams.fonts)
        .filter(function (_a) {
        var key = _a[0];
        return !(0, css_variables_utils_1.isGlobalFont)(styles.siteTextPresets, key);
    })
        .forEach(function (_a) {
        var key = _a[0], font = _a[1];
        try {
            var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, cssFunctions_1.cssFunctions.font(font, tpaParams));
            cssVariables[cssVariable.key] = cssVariable.value;
            (0, css_variables_utils_1.addFontSubVariables)({ cssVariable: cssVariable, font: font, addTextDecoration: true }, cssVariables);
        }
        catch (e) {
            // swallow
        }
    });
    // custom expressions
    var processor = (0, processor_1.getProcessor)({ cssVars: cssVars, plugins: common_1.plugins });
    Object.entries(customExpressions).forEach(function (_a) {
        var key = _a[0], expression = _a[1];
        try {
            var value = processor.process({
                part: expression,
                tpaParams: tpaParams,
            });
            var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, value);
            cssVariables[cssVariable.key] = cssVariable.value;
        }
        catch (e) {
            // swallow
        }
    });
    if (typeof customCssVars === 'function') {
        var customCssVarsValue = customCssVars({
            styleParams: tpaParams,
            isMobile: options.isMobile,
            isRTL: options.isRTL,
            tpaData: tpaData,
        });
        Object.entries(customCssVarsValue).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, String(value));
            cssVariables[cssVariable.key] = cssVariable.value;
        });
    }
    Object.assign(cssVariables, (0, exports.getStyleParamCssVariables)(styleParamsWithMetadataDefaults));
    return {
        variables: cssVariables,
        stylesheet: (0, css_variables_utils_1.toStylesheet)(cssVariables),
    };
}
exports.getComponentCssVariables = getComponentCssVariables;
function getSiteCssVariables(siteColors, siteTextPresets, siteThemeVars) {
    var cssVariables = siteThemeVars ? (0, exports.getThemeCssVariables)(siteThemeVars) : {};
    var emptyTpaParams = {
        booleans: {},
        colors: {},
        fonts: {},
        numbers: {},
        strings: {},
    };
    var _a = (0, generateTPAParams_1.getSiteLevelStyles)(siteColors, siteTextPresets), colors = _a.colors, fonts = _a.fonts;
    // colors
    Object.entries(colors)
        .filter(function (_a) {
        var key = _a[0];
        return (0, css_variables_utils_1.isGlobalColor)(key);
    })
        .forEach(function (_a) {
        var key = _a[0], color = _a[1];
        var rgbParts = (0, cssFunctions_1.toRgbParts)(cssFunctions_1.cssFunctions.color(color, emptyTpaParams));
        var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, rgbParts.full, prefixes.siteColors);
        cssVariables[cssVariable.key] = cssVariable.value;
    });
    // fonts
    Object.entries(fonts)
        .filter(function (_a) {
        var key = _a[0];
        return (0, css_variables_utils_1.isGlobalFont)(siteTextPresets, key);
    })
        .forEach(function (_a) {
        var key = _a[0], font = _a[1];
        var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, cssFunctions_1.cssFunctions.font(font, emptyTpaParams), prefixes.textPresets);
        cssVariables[cssVariable.key] = cssVariable.value;
        (0, css_variables_utils_1.addFontSubVariables)({ cssVariable: cssVariable, font: font, addTextDecoration: true }, cssVariables);
    });
    return {
        variables: cssVariables,
        stylesheet: (0, css_variables_utils_1.toStylesheet)(cssVariables),
    };
}
exports.getSiteCssVariables = getSiteCssVariables;
var getStyleParamCssVariables = function (styleParamsWithMetadataDefaults) {
    var result = {};
    Object.entries(styleParamsWithMetadataDefaults).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value.type === editor_platform_ooi_metadata_resolver_1.StyleType.font) {
            try {
                var parsedFont = wixStyleFontUtils_1.wixStylesFontUtils.parseFontFromString(value.cssValue);
                var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, value.cssValue);
                result[cssVariable.key] = cssVariable.value;
                if (parsedFont && !('system' in parsedFont)) {
                    (0, css_variables_utils_1.addFontSubVariables)({ cssVariable: cssVariable, font: parsedFont }, result);
                }
            }
            catch (e) { }
        }
        else if ((0, css_variables_utils_1.isColorStyleType)(value.type)) {
            try {
                var rgbParts = (0, cssFunctions_1.toRgbParts)(value.cssValue);
                var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, rgbParts.full);
                result[cssVariable.key] = cssVariable.value;
                (0, css_variables_utils_1.addColorSubVariables)({ cssVariable: cssVariable, rgbParts: rgbParts }, result);
            }
            catch (e) { }
        }
        else {
            try {
                var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, value.cssValue);
                result[cssVariable.key] = cssVariable.value;
            }
            catch (e) { }
        }
    });
    return result;
};
exports.getStyleParamCssVariables = getStyleParamCssVariables;
var getThemeCssVariables = function (themeVariables) {
    var result = {};
    Object.entries(themeVariables).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (!(0, wix_site_theme_variables_1.isWixThemeVariable)(key)) {
            return;
        }
        if ((0, css_variables_utils_1.isColorTypeThemeVariable)(key)) {
            try {
                var rgbParts = (0, cssFunctions_1.toRgbParts)(value);
                var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, rgbParts.full);
                result[cssVariable.key] = cssVariable.value;
                (0, css_variables_utils_1.addColorSubVariables)({ cssVariable: cssVariable, rgbParts: rgbParts }, result);
            }
            catch (e) { }
        }
        else if ((0, css_variables_utils_1.isTextFontThemeVariable)(key)) {
            try {
                var parsedFont = wixStyleFontUtils_1.wixStylesFontUtils.parseFontFromString(value);
                if (parsedFont && !('system' in parsedFont)) {
                    var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, value);
                    var temp = {};
                    result[cssVariable.key] = cssVariable.value;
                    (0, css_variables_utils_1.addFontSubVariables)({ cssVariable: cssVariable, font: parsedFont }, temp);
                    (0, css_variables_utils_1.remapThemeFontLineHeightKey)(cssVariable.key, temp);
                    Object.assign(result, temp);
                }
            }
            catch (e) { }
        }
        else {
            try {
                var cssVariable = (0, css_variables_utils_1.emitCssVariable)(key, value);
                result[cssVariable.key] = cssVariable.value;
            }
            catch (e) { }
        }
    });
    return result;
};
exports.getThemeCssVariables = getThemeCssVariables;
//# sourceMappingURL=css-variables.js.map